import type { PlayerType } from "@rosette/ts/src/royalur/model/PlayerType.js";
import { useRef } from "react";
import { Rune } from "@rosette/ts/src/business/Rune.js";


export class SharedRendererState {
    highlightIntroducedPiece: PlayerType | null = null;
    currentMoveIndex: Rune<number> = new Rune<number>(-1);
    isAnimatingQuickMoves: Rune<boolean> = new Rune<boolean>(false);
}


export function useCreateSharedRendererState(): SharedRendererState {
    const sharedRendererStateRef = useRef<SharedRendererState | null>(null);
    if (sharedRendererStateRef.current === null) {
        sharedRendererStateRef.current = new SharedRendererState();
    }

    const sharedRendererState = sharedRendererStateRef.current;
    if (!sharedRendererState)
        throw new Error("Missing shared renderer state");

    return sharedRendererState;
}
